const ProgramGrid = () => {
  const body = document.querySelector('body');
  const grids = document.querySelectorAll('.program-grid__table');
  const breakpoint = body.getAttribute('data-breakpoint');

  if (! grids) {
    return false;
  }

  grids.forEach(grid => {
    handleTableHeader(grid);

    setCellCardHeight(grid);

    tableScrollGradient(grid);

    resizeObserver(grid);

    arrowsListener(grid);
  });

  // Set Cards Height to fill entire table cell
  // especially if parent `td` spans multiple rows
  // Resolves browser bug in Chrome and Safari
  function setCellCardHeight(grid) {
    const gridRows = grid.querySelectorAll('tbody tr');

    gridRows.forEach(row => {
      let rowHeight = 0;

      if (grid.classList.contains('program-grid__table--plain') || grid.classList.contains('program-grid__table--richdata')) {
        rowHeight = row.offsetHeight;
      } else {
        rowHeight = 180;
      }

      const cells = row.querySelectorAll('th[scope=row], td');

      cells.forEach(cell => {
        const cellRowSpan = cell.getAttribute('rowspan');
        const cellCard = cell.querySelector('div');

        if (cellCard) {
          cellCard.setAttribute('style', `min-height: ${ cellRowSpan ? rowHeight * cellRowSpan : rowHeight }px`);
        }
      });
    });
  }

  // Determine the table header if merged
  function handleTableHeader(grid) {
    const tableHead = grid.querySelectorAll('th');

    tableHead.forEach(head => {
      const colSpan = head.getAttribute('colspan');
      if (colSpan) {
        head.style.width = (parseInt(colSpan) * 180) + 'px';
      }
    });
  }

  // Add Gradient to indicate scrollable content
  function tableScrollGradient(grid) {
    const tableScroller = grid.querySelector('.program-grid__table-scroller');

    if (tableScroller.scrollWidth > tableScroller.clientWidth) {
      tableScroller.classList.add('is-scrollable');
    } else {
      tableScroller.classList.remove('is-scrollable');
    }

    tableScroller.addEventListener('scroll', e => {
      const target = e.target;

      if (target.scrollLeft >= 50) {
        target.classList.add('has-scrolled');
      } else {
        target.classList.remove('has-scrolled');
      }
    });
  }

  function resizeTableContainer(grid) {
    const isArticleDetailPage = document.querySelector('.page--article') || document.querySelector('.page--detail');

    if (isArticleDetailPage) {
      const mainWrapper = document.querySelector('.main__wrapper');
      const mainContainer = mainWrapper.querySelector('.container');
      const railArea = document.querySelector('.rail-area');
      const gridContent = grid.closest('.content');

      const offset = (mainWrapper.clientWidth - mainContainer.clientWidth) / 2;
      const width = (mainWrapper.clientWidth - railArea.clientWidth) - offset;

      gridContent.setAttribute('style', `max-width: ${ width }px`);
    }
  }

  function debounce(func, wait, immediate) {
    let timeout;
    return function() {
      const context = this,
        args = arguments;
      const later = function() {
        timeout = null;
        if (! immediate) {
          func.apply(context, args);
        }
      };
      const callNow = immediate && ! timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  function resizeObserver(grid) {
    window.addEventListener('resize', debounce(() => {
      handleTableHeader(grid);
      tableScrollGradient(grid);
      setCellCardHeight(grid);
      arrowsListener(grid);

      if (breakpoint === 'desktop') {
        resizeTableContainer(grid);
      }
    }, 200));
  }

  function arrowsListener(grid) {
    // selectors
    const arrowRight = grid.querySelector('.js-program-grid__table-arrow--right');
    const scroller = grid.querySelector('.program-grid__table-scroller');

    // settings
    let isArrowInRightDirection = true;
    const SCROLL_VALUE = 200;
    const isNoNeedForArrowRight = scroller.scrollLeft + scroller.offsetWidth >= scroller.scrollWidth;

    // classes
    const reverseClass = 'program-grid__table-arrow--reverse';
    const hiddenClass = 'program-grid__table-arrow--hidden';

    if (isNoNeedForArrowRight) {
      arrowRight.classList.add(hiddenClass);
    } else {
      arrowRight.classList.remove(hiddenClass);
    }

    arrowRight.addEventListener('click', () => {
      scroller.scrollBy({
        left: isArrowInRightDirection ? SCROLL_VALUE : scroller.scrollLeft * -1,
        behavior: 'smooth',
      });
    });

    scroller.addEventListener('scroll', () => {
      const { scrollLeft, offsetWidth, scrollWidth } = scroller;

      const isAtRightEnd = scrollLeft + offsetWidth >= scrollWidth;
      isArrowInRightDirection = ! isAtRightEnd;

      if (isAtRightEnd) {
        arrowRight.classList.add(reverseClass);
      } else {
        arrowRight.classList.remove(reverseClass);
      }
    });
  }
};

export default ProgramGrid;
